import { Component } from '@angular/core';

/**
 * Generated class for the AddIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'add-icon',
  templateUrl: 'add-icon.html'
})
export class AddIconComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/add-icon/add-icon.ts